// core version + navigation, pagination modules:
import Swiper, { Autoplay } from 'imports/swiper'

const home = {
    init() {
        document.querySelectorAll('.week-in-review.module-promo').forEach((wrap) => {
            const image = wrap.querySelector('.video-wrapper')
            const embed = wrap.querySelector('.embed')
            const iframe = embed?.querySelector('iframe')

            if (!image || !embed || !iframe) return

            // keep hidden until click; CSS controls visibility
            // ensure autoplay-ready src on click
            const addAutoplay = (url) => {
                if (!url) return url
                const hasQuery = url.includes('?')
                const sep = hasQuery ? '&' : '?'
                // add autoplay + mute + playsinline for mobile
                const must = 'autoplay=1&mute=0&playsinline=1'
                return url.includes('autoplay=1') ? url : `${url}${sep}${must}`
            }

            image.addEventListener('click', function handler() {
                // force show by class toggle
                wrap.classList.add('is-playing')

                // lazy-upgrade src for autoplay if needed
                if (iframe) {
                    // if using data-src pattern, prefer that
                    const dataSrc = iframe.getAttribute('data-src')
                    if (dataSrc && !iframe.src) {
                        iframe.src = addAutoplay(dataSrc)
                    } else {
                        iframe.src = addAutoplay(iframe.src)
                    }
                }

                // remove event listener after first click
                image.removeEventListener('click', handler)
            })
        })
    }
}

export default home
